import React from "react";

import { stringToTitleCase } from "../../utility";
import CategoriesDropdown from "../selectDropdown/CategoriesDropdown";
import { categoryDropdownConstants, EMPTY_STRING } from "../../../constants";

const SelectDropdownFormik = (props) => {
  const {
    name,
    value,
    setFieldValue,
    disabled = false,
    className = EMPTY_STRING,
    wrapperClassname = EMPTY_STRING,
    noOptionsMessage = EMPTY_STRING,
    options = [{ label: EMPTY_STRING, value: EMPTY_STRING }],
  } = props;

  return (
    <CategoriesDropdown
      value={value}
      SelectIconImage={categoryDropdownConstants.INVENTORY_LIST_ICON}
      className={className}
      isClearable={false}
      disabled={disabled}
      wrapperClassname={wrapperClassname}
      placeholder={`Select ${stringToTitleCase(name)}`}
      noOptionsMessage={
        noOptionsMessage
          ? noOptionsMessage
          : `No ${stringToTitleCase(name)} Found`
      }
      formik={{
        name: name,
        value: value,
        isFormikField: true,
        setFieldValue: setFieldValue,
      }}
      options={options}
    />
  );
};

export default SelectDropdownFormik;
